// Models/Schemas/form-restaurants-edit.js
import * as Yup from "yup";

export const FormRestaurantEditScheme = () => {
  return Yup.object().shape({
    // name, phone y costoEnvio NO se validan: son fijos desde la creación del negocio,
    // el dueño ya no los puede editar (campos disabled en el form), solo el admin.
    categoriaPrincipal: Yup.string()
      .required("La categoría principal es obligatoria")
      .trim(),

    // 👇 ahora solo valida subcategorías
    categorias: Yup.array()
      .of(Yup.string().trim())
      .min(1, "Debes seleccionar al menos una subcategoría"),

    email: Yup.string()
      .email("Correo inválido")
      .required("El correo es obligatorio"),
    tiempoEntregaEstimado: Yup.number()
      .min(10, "El tiempo mínimo es 10 minutos")
      .max(120, "El tiempo máximo es 120 minutos")
      .required("El tiempo estimado es obligatorio"),
    horarios: Yup.object().nullable(), // 👈 ahora validamos como objeto genérico
  });
};
